import React, { useEffect, useState } from 'react'
import { Toast } from './Toast'
import type { IconName } from '../../../shared/webcomponents/helpers/icons'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import { v4 as uuidv4 } from 'uuid'

export type ToastInfo = {
    id: UUID
    message: string
    icon: IconName
    duration?: number
    delay?: number
    color?: any
    onClose?: () => void
    onClick?: () => void
    actionButtonText?: string
    hideDismissButton?: boolean
}

type Props = {
    limit?: number
}

enum Events {
    popToast = 'pop-toast',
}

const defaults = {
    limit: 3,
}

export function popToast(info: Omit<ToastInfo, 'id'>) {
    document.dispatchEvent(new CustomEvent(Events.popToast, { detail: info }))
}

export function Toaster({ limit }: Props) {
    limit ??= defaults.limit

    const [toasts, setToasts] = useState<ToastInfo[]>([])

    const add = (toast: ToastInfo) => setToasts([...toasts, toast].slice(-limit))

    const remove = (id: UUID) => setToasts(toasts.filter((toast) => toast.id !== id))

    const handlePop = ({ detail }: CustomEvent<Omit<ToastInfo, 'id'>>) => add({ id: uuidv4() as UUID, ...detail })

    useEffect(() => {
        document.addEventListener(Events.popToast, handlePop)
        return () => document.removeEventListener(Events.popToast, handlePop)
    })

    return (
        <div className="AppCore__ui__Toaster">
            {toasts.map(
                ({
                    message,
                    icon,
                    id,
                    duration,
                    delay,
                    color,
                    onClick,
                    onClose,
                    actionButtonText,
                    hideDismissButton,
                }) => (
                    <Toast
                        key={id}
                        message={message}
                        icon={icon}
                        duration={duration}
                        delay={delay}
                        color={color}
                        onClose={() => {
                            onClose && onClose()
                            remove(id)
                        }}
                        onClick={() => {
                            onClick && onClick()
                            remove(id)
                        }}
                        actionButtonText={actionButtonText}
                        hideDismissButton={hideDismissButton}
                    />
                )
            )}
        </div>
    )
}
